export default {
    Images: {
        icon: require("../assets/image/icon.png"),
        logo:  require("../assets/image/logo.png"),
        icon_white: require("../assets/image/icon-whiteBg.jpg"),
        userIcon: require("../assets/image/userIcon.png"),
        userIcon2: require("../assets/image/userIcon2.jpg"),
        backgroung: require("../assets/image/background.png"),
        backgroung2: require("../assets/image/background2.png"),
    }
}